import type { DisplayEnum } from '.';
import { convertToDisplayEnum, makeConfig } from './utils';

export type CurrencyTypes = keyof typeof currencyTypeDisplayNames;

const currencyTypeDisplayNames = {
  USD: 'USD',
  ARS: 'ARS',
  BRL: 'BRL',
  CLP: 'CLP',
  COP: 'COP',
  MXN: 'MXN',
  AUD: 'AUD',
  NZD: 'NZD',
  PEN: 'PEN',
  EUR: 'EUR',
  TRY: 'TRY',
  SEK: 'SEK',
  GBP: 'GBP',
  DKK: 'DKK',
  NOK: 'NOK',
  CHF: 'CHF',
  CAD: 'CAD',
  CRC: 'CRC',
  GTQ: 'GTQ',
  PAB: 'PAB',
  UYU: 'UYU',
  AED: 'AED',
  CNY: 'CNY',
  CZK: 'CZK',
  EGP: 'EGP',
  HKD: 'HKD',
  HUF: 'HUF',
  IDR: 'IDR',
  ILS: 'ILS',
  INR: 'INR',
  ISK: 'ISK',
  JPY: 'JPY',
  KES: 'KES',
  KRW: 'KRW',
  LKR: 'LKR',
  MYR: 'MYR',
  NGN: 'NGN',
  PHP: 'PHP',
  PLN: 'PLN',
  RON: 'RON',
  SAR: 'SAR',
  SGD: 'SGD',
  THB: 'THB',
  TWD: 'TWD',
  VES: 'VES',
  VND: 'VND',
  ZAR: 'ZAR',
};

export const currencyTypes = makeConfig<CurrencyTypes>(currencyTypeDisplayNames);

export function convertCurrencyTypes(apiValue: string): DisplayEnum<CurrencyTypes> {
  return convertToDisplayEnum(apiValue, currencyTypes);
}
